import { CashOption, PaymentType, SchemaTypes } from '@allesauto/graphql';
import type { IProductDetails } from '@allesauto/utils/interfaces';
import isNil from 'lodash/isNil';

export const vehicleToCartItemInput = (
  product: IProductDetails
): SchemaTypes.CartItemInput => {
  const { financing, paymentType, dealerId, productType, sku } = product;

  // if the payment type is not cash and we have financing data (from the leasing or the financing form)
  const hasFinancing = paymentType !== PaymentType.CashRange && financing;

  return {
    sku,
    quantity: 1,
    productType,
    dealerId,
    paymentOptions: {
      financeCalculation: hasFinancing
        ? {
            downPayment: financing.downPayment ?? 0,
            duration: financing.duration ?? 0,
            mileage: financing.mileage ?? 0,
            // the flag is only for the financing (loan) form
            // it's false if there is no finalInstallment field in the form values
            hasFinalInstallment:
              paymentType === PaymentType.LoanRateRange
                ? !isNil(financing.finalInstallment)
                : undefined,
            finalInstallment: financing.finalInstallment ?? 0,
          }
        : undefined,
      paymentType: paymentType,
      cashOption:
        paymentType === PaymentType.CashRange
          ? CashOption.Prepayment
          : CashOption.Dealer,
    },
  };
};
